/**
 * vx-bundle-carousel is a carousel component
 * with vx-slider embedded in it.
 */
import vxSlider from '../vx-slider/vx-slider.vue';
import globals from '../../common/globals';
import { ProductAvailability } from '../../common/mixins/vx-enums';

export default {
  name: 'vx-bundle-carousel',
  components: {
    vxSlider,
  },
  props: {
    i18n: {
      type: Object,
      required: true,
    },
    bundleCarouselTitle: {
      type: String,
      default: '',
    },
    bundleCarouselData: {
      type: Object,
      default: {},
    },
  },
  computed: {},
  data() {
    return {
      globals,
      ProductAvailability,
      sliderSlides: {
        desktop: {
          slides: 4,
          spaceAllowed: 0,
        },
        tablet: {
          slides: 4,
          spaceAllowed: 16,
        },
        mobile: {
          slides: 2,
          spaceAllowed: 16,
        },
    },
      isDisabled: false,
    };
  },
  async mounted() {
    this.isDisabled = this.bundleCarouselData.materialStatus === this.ProductAvailability.COMING_SOON ||
    (this.bundleCarouselData.stock.stockLevelStatus.code === this.ProductAvailability.OUT_OF_STOCK && !this.bundleCarouselData.stock.nextAvailableDate);
  },
  methods: {
    /**
     * triggered on click of the bundle
     *  button to navigate to that bundle page.
     * @param {string} bundleId
     * @return {object} null
     */
    navigateToBundle(bundleId) {
      window.location.href = `${this.globals.getNavBaseUrl()}${this.globals.navigations.bundlePage}/?bundleId=${bundleId}&productCode=${this.bundleCarouselData.code}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pdp/vx-bundle-carousel/vx-bundle-carousel.js